import { useEffect, useState } from 'react';

interface UseTimerParams {
  initialSeconds: number;
  onExpire?: () => void;
}

type UseTimerReturns = {
  timeLeft: number;
  formatTime: (seconds: number) => string;
  reset: (seconds?: number) => void;
  isExpired: boolean;
};

export function useTimer(params: UseTimerParams): UseTimerReturns {
  const { initialSeconds, onExpire } = params;
  const [timeLeft, setTimeLeft] = useState(initialSeconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          onExpire?.();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onExpire]);

  const formatTime = (seconds: number): string => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  const reset = (seconds?: number) => {
    setTimeLeft(seconds ?? initialSeconds);
  };

  return {
    timeLeft,
    formatTime,
    reset,
    isExpired: timeLeft === 0,
  };
}
